<div id="popup">
  <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
    <span style="font-weight:700;">
      INSERT TABLE
    </span>
    <button [attr.guide]="'insert-table-dialog-btn-close' + '__' + sanitizeUrl(url)" mat-icon-button (click)="cancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style="margin: 0px; padding: 12px 16px;">
    <div class="padding-11">
      <div fxLayout="column" fxLayoutGap="12px">

        <div fxLayout="column" fxLayout.gt-sm="column" fxLayoutGap.gt-sm="24px" fxLayoutAlign="start center">
         
           <mat-form-field appearance="outline" fxFlex>
            <mat-label>Number of Rows:</mat-label>
            <input [attr.guide]="'insert-table-dialog-inp-1' + '__' + sanitizeUrl(url)" matInput type="number" min="1" [(ngModel)]="rows"/>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Number of Columns:</mat-label>
            <input [attr.guide]="'insert-table-dialog-inp-2' + '__' + sanitizeUrl(url)" matInput type="number" min="1" [(ngModel)]="cols"/>
          </mat-form-field>

         
        </div>

        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <button [attr.guide]="'insert-table-dialog-btn-3' + '__' + sanitizeUrl(url)" type="button" mat-raised-button (click)="cancel()">Cancel</button>
          <button [attr.guide]="'insert-table-dialog-btn-4' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="ok()">OK</button>
        </div>

      </div>
    </div>
  </mat-dialog-content>
</div>




